import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import { mapFamilyApiError } from '~entities/family/lib/map-family-api-error';
import type { FamilyCommunicationLevel } from '~entities/family/model/family.type';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export const addFamilyContact = async (args: {
  familyId: string;
  parentId: string;
  isBillingContact?: boolean;
  communicationLevel?: FamilyCommunicationLevel;
  portalAccessEnabled?: boolean;
}) => {
  const { familyId, ...body } = args;
  const response = await baseAPI.post(
    `/v2/families/${familyId}/contacts`,
    body,
  );
  return response.data;
};

export const useAddFamilyContact = (studentId?: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: addFamilyContact,
    onSuccess: () => {
      toast.success('Guardian linked to family');
      void queryClient.invalidateQueries({
        queryKey: [KEYS.FAMILY_BY_STUDENT],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.FAMILY_HUB],
      });
    },
    onError: (error: unknown) => {
      toast.error(mapFamilyApiError(error, 'Failed to link guardian'));
    },
  });
};
